import React from 'react';
import { Field, Formik } from 'formik';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@material-ui/core';
import * as Yup from 'yup';

import {
  GQLAccessoryModelInput,
  GQLAccessorySize,
  GQLMaterialType,
  GQLParty,
  GQLPlatingType
} from '@jewelutions/core-crm-server-api-client-domain';

import { JwlField, JwlSelect } from '../../../../components';
import { SelectOption } from '../../../../components/JwlSelect/JwlSelect';
import { stringListToDisplayValueList } from '../../../../core/utils';
import { GQLOperationBuilder } from '../../../../operations/GQLOperationBuilder';
import { ErrorMessage } from '../../../../types-hack';

interface IProps {
  accessoryId: string;
  party: GQLParty;
  onClose: (success: boolean) => void;
}

const availableAccessorySizes: SelectOption[] = stringListToDisplayValueList(Object.keys(GQLAccessorySize));

const initialValues = {
  sizeType: GQLAccessorySize.Small,
  dimensions: {
    width: 1,
    height: 1,
    depth: 1
  }
};

const AccessoryModelCreateDialog: React.FC<IProps> = ({ party, accessoryId, onClose }) => {
  const [saveAccessoryModel, { error, loading }] = GQLOperationBuilder.accessory.createAccessoryModel();

  const validationSchema = Yup.object({});

  const onSubmit = (props: any) => {
    const input: GQLAccessoryModelInput = {
      availableConfigurations: [
        {
          sizeType: props.sizeType,
          materialType: GQLMaterialType.Silver,
          platingType: GQLPlatingType.Rhodium
        }
      ],
      dimensions: {
        width: Number.parseFloat(props.dimensions.width),
        height: Number.parseFloat(props.dimensions.height),
        depth: Number.parseFloat(props.dimensions.depth)
      },
      sizeType: props.sizeType,
      weights: [
        {
          configuration: {
            sizeType: props.sizeType,
            materialType: GQLMaterialType.Silver,
            platingType: GQLPlatingType.Rhodium
          },
          weightInGrams: 0
        }
      ]
    };

    const mutationVariables = { input: input, accessoryId: accessoryId };

    saveAccessoryModel({ variables: mutationVariables }).then(_result => {
      onClose(true);
    });
  };

  return (
    <Dialog open aria-labelledby="model-dialog">
      <DialogTitle>{`Create accessory model`}</DialogTitle>
      <DialogContent>
        <div>
          <Formik initialValues={initialValues} validationSchema={validationSchema} onSubmit={onSubmit}>
            {({ values, handleSubmit }) => (
              <form onSubmit={handleSubmit} className="flex flex-col">
                <Field
                  name="sizeType"
                  component={JwlSelect}
                  label="Size Type"
                  options={availableAccessorySizes}
                />
                <ErrorMessage component="span" name="sizeType" className="fs-12 text-error" />

                <div style={{ height: '200px' }}>
                  <span>Dimensions</span>
                  <Field name="dimensions.height" component={JwlField} label="Height (mm)" />
                  <ErrorMessage component="span" name="dimensions.height" className="fs-12 text-error" />

                  <Field name="dimensions.width" component={JwlField} label="Width (mm)" />
                  <ErrorMessage component="span" name="dimensions.width" className="fs-12 text-error" />

                  <Field name="dimensions.depth" component={JwlField} label="Depth (mm)" />
                  <ErrorMessage component="span" name="dimensions.depth" className="fs-12 text-error" />
                </div>

                <DialogActions>
                  <Button color="primary" onClick={() => onClose(false)}>
                    Close
                  </Button>
                  <Button type="submit" color="primary" variant="contained">
                    Save
                  </Button>
                </DialogActions>
              </form>
            )}
          </Formik>
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default AccessoryModelCreateDialog;
